import { render, staticRenderFns } from "./r-icon.vue?vue&type=template&id=3eb81838"
import script from "./r-icon.vue?vue&type=script&lang=js"
export * from "./r-icon.vue?vue&type=script&lang=js"
import style0 from "./r-icon.vue?vue&type=style&index=0&id=3eb81838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports